import createPersistedState from "vuex-persistedstate";
import { application } from "./applicationState.js";
import { wishlist } from "./wishlist.js";
import { cart } from "./cart.js";
import { user } from "./user.js";
import { websocket } from "./websocket.js";
import { liveBigScreen } from "./liveBigScreen.js";
import { liveAuctionState } from "./liveAuctionState.js";
import { liveAdminAuctionState } from "./liveAdminAuctionState.js";
import { qualificationState } from "./qualificationState.js";
import authStorage from '@/utils/authStorage';

export const dataState = createPersistedState({
  paths: ['user', 'application', 'cart', 'wishlist', 'websocket', 'liveBigScreen'],
  storage: {
    getItem: (key) => {
      const value = localStorage.getItem(key)
      return value
    },
    setItem: (key, value) => {
      const stateToSave = JSON.parse(value)

      // 获取当前的 localStorage 中的状态
      const currentState = localStorage.getItem(key)
      const currentParsed = currentState ? JSON.parse(currentState) : {}

      // 获取 token 状态
      const tokenInStorage = authStorage.getToken()

      // console.log('=== 详细保存日志 ===')
      // console.log('时间:', new Date().toLocaleTimeString())
      // console.log('token in storage:', tokenInStorage)
      // console.log('token in new state:', stateToSave.user?.auth?.access_token)
      // console.log('user auth in new state:', stateToSave.user?.auth)
      // console.log('user auth in current storage:', currentParsed.user?.auth)

      // 检查是否有清空操作
      if (currentParsed.user?.auth?.access_token &&
        !stateToSave.user?.auth?.access_token) {
        // console.warn('⚠️ 检测到 token 被清空！')
        // console.warn('调用堆栈:', new Error().stack)
      }

      // 保护逻辑：如果 storage 中有 token，但新状态中没有，恢复 token
      if (tokenInStorage &&
        stateToSave.user &&
        !stateToSave.user.auth?.access_token) {

        //console.log('🛡️ 保护机制触发：恢复 token')

        if (!stateToSave.user.auth) {
          stateToSave.user.auth = {}
        }
        stateToSave.user.auth.access_token = tokenInStorage

        // 同时恢复其他必要的字段
        if (currentParsed.user?.auth) {
          stateToSave.user.auth = {
            ...currentParsed.user.auth,
            access_token: tokenInStorage
          }
        }
      }

      // if (!authStorage.isAuthenticated() && stateToSave.user) {
      //   console.log(stateToSave.user, 11122222, (!authStorage.isAuthenticated() && stateToSave.user))
      //   stateToSave.user.auth = {
      //     access_token: null,
      //     role: 'guest1',
      //     email: null,
      //     name: null,
      //     permissions: [],
      //     sub: null,
      //     identifier: null,
      //     grant_type: null,
      //     scope: [],
      //     token_type: null,
      //     expires_in: null,
      //     client_id: null,
      //     authorities: []
      //   }
      // }
      localStorage.setItem(key, JSON.stringify(stateToSave))
    },
    removeItem: (key) => {
      localStorage.removeItem(key)
    }
  }
})

export const modules = {
  app: application,
  wishlist,
  cart,
  user,
  websocket,
  liveBigScreen,
  liveAuctionState,
  liveAdminAuctionState,
  qualificationState
};
